// extracted by mini-css-extract-plugin
export default {"brands":"Brands_brands__8zie9","slider":"Brands_slider__5KYl2","slide":"Brands_slide__0Gr09","img":"Brands_img__A0nPb"};